import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import usePreventNavigation from '../../../../hooks/usePreventNavigation';
import RegularProductConfig from '../regular/RegularProductConfig';
import { usePreCartOfferProductsToPrompt } from '../../../../hooks/usePreCartOfferProductsToPrompt';

const PreCartOfferConfig = ({ history }) => {
  // Keep the parent on this route until the offer is handled.
  usePreventNavigation(history, '/v3/pre-cart-offers');

  const searchParams = new URLSearchParams(location.search);
  const redirectSource = searchParams.get('source');

  const preCartOfferProductsToPrompt = usePreCartOfferProductsToPrompt();
  const prevLocation = useSelector((state) => state.uiLocation.previous);
  const offeredProduct =
    preCartOfferProductsToPrompt.length > 0
      ? preCartOfferProductsToPrompt[0]
      : null;

  useEffect(() => {
    if (preCartOfferProductsToPrompt.length === 0) {
      history.push(prevLocation === '/v3/cart' ? '/v3/offers' : '/v3/cart');
    }
  }, [preCartOfferProductsToPrompt, prevLocation, history]);

  // Announce the offer. The isPreCartOfferProduct flow flag is derived from
  // the route (useIsPreCartOfferFlow); this wrapper owns the announcement.
  // offeredProduct is a stable reference into shoot.preCartOfferProducts, so
  // this fires once per distinct product.
  useEffect(() => {
    if (!offeredProduct) return;

    Swal.fire(
      'Is Your Cart Missing Something?',
      'Here is a product we think you might like!',
    );
  }, [offeredProduct]);

  return offeredProduct ? (
    <RegularProductConfig
      hideBackLink={true}
      redirectSource={redirectSource}
      product={offeredProduct}
    />
  ) : null;
};

PreCartOfferConfig.propTypes = {
  history: PropTypes.object.isRequired,
};

export default PreCartOfferConfig;
